var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5828 0.191387C15.1339 -0.13039 14.5092 -0.0274177 14.1874 0.421387L4.83077 13.4667L1.70744 10.3407C1.45485 10.088 1.08664 9.98926 0.741494 10.0817C0.396351 10.174 0.126717 10.4436 0.0341609 10.7887C-0.0583955 11.1338 0.0401874 11.502 0.292774 11.7547L4.24944 15.7107C4.45958 15.9129 4.74642 16.0152 5.03708 15.9914C5.32773 15.9677 5.59421 15.8203 5.76877 15.5867L15.8128 1.58672C16.1346 1.13789 16.0316 0.513197 15.5828 0.191387Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.be9c477b7af75294637ba0bfb1af3657.svg";
export { ForwardRef as ReactComponent };